import { Link } from "react-router-dom";
import "../styles/Home.css";

export default function Home() {
  return (
    <div className="home">
      {/* ================= NAVBAR ================= */}
      <nav className="navbar">
        <div className="logo">🎓 QuizLMS</div>
        <div className="nav-actions">
          <Link to="/login" className="nav-btn">
            Login
          </Link>
          <Link to="/signup" className="nav-btn primary">
            Sign Up
          </Link>
        </div>
      </nav>

      {/* ================= HERO ================= */}
      <section className="hero">
        <div className="hero-text">
          <h1>Learn. Attempt. Analyse.</h1>
          <p>
            A modern online quiz-based learning platform built using the MERN
            stack with real-time analytics and progress tracking.
          </p>
          <Link to="/signup" className="hero-btn">
            Get Started
          </Link>
        </div>

        <div className="hero-image">
          <img
            src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bGVhcm5pbmclMjBtYW5hZ2VtZW50JTIwc3lzdGVtfGVufDB8fDB8fHww"
            alt="Learning"
          />
        </div>
      </section>

      {/* ================= FEATURES ================= */}
      <section className="features">
        <h2>Why Choose QuizLMS?</h2>

        <div className="feature-grid">
          <div className="feature-card">
            <img src="https://cdn-icons-png.flaticon.com/512/3135/3135755.png" />
            <h3>Category-based Quizzes</h3>
            <p>Choose quizzes by topic and difficulty.</p>
          </div>

          <div className="feature-card">
            <img src="https://cdn-icons-png.flaticon.com/512/942/942748.png" />
            <h3>Instant Results</h3>
            <p>Get your score immediately after submission.</p>
          </div>

          <div className="feature-card">
            <img src="https://cdn-icons-png.flaticon.com/512/1828/1828911.png" />
            <h3>Performance Analytics</h3>
            <p>Track progress using interactive charts.</p>
          </div>
        </div>
      </section>

      {/* ================= HOW IT WORKS ================= */}
      <section className="how-it-works">
        <h2>How It Works</h2>

        <div className="steps">
          <div className="step">
            <span>1</span>
            <p>Create an account or login</p>
          </div>
          <div className="step">
            <span>2</span>
            <p>Select a quiz category</p>
          </div>
          <div className="step">
            <span>3</span>
            <p>Attempt multiple-choice questions</p>
          </div>
          <div className="step">
            <span>4</span>
            <p>View results and analytics</p>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="footer">
        <p>© 2025 QuizLMS | MERN-Based Online Learning System</p>
      </footer>
    </div>
  );
}
